<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button v-if="hasExport" type="primary" @click="onMonthDown">月度汇总绩效导出</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <el-form-item prop="ygDate" label="统计日期">
          <el-date-picker
            v-model="dateArr"
            start-placeholder="请选择开始日期"
            end-placeholder="请选择结束日期"
            type="daterange"
            clearable
            @change="handleDateChange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <div class="count-items">
        <div class="count-item">
          <div class="count-item-title">总绩效</div>
          <div class="count-item-value">{{ formData.zj || '0' }}</div>
        </div>
        <div class="count-item">
          <div class="count-item-title">出库绩效</div>
          <div class="count-item-value">{{ formData.cq || '0' }}</div>
        </div>
        <div class="count-item">
          <div class="count-item-title">入库绩效</div>
          <div class="count-item-value">{{ formData.cj || '0' }}</div>
        </div>
        <div class="count-item">
          <div class="count-item-title">货转/调拨绩效</div>
          <div class="count-item-value">{{ formData.hz || '0' }}</div>
        </div>
      </div>
    </el-card>

    <el-card shadow="never" class="mt10">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="出库" name="1"></el-tab-pane>
        <el-tab-pane label="入库" name="2"></el-tab-pane>
        <el-tab-pane label="调拨" name="3"></el-tab-pane>
      </el-tabs>
      <el-button class="export" v-if="hasExport" type="primary" @click="handleExportPdf">导出</el-button>

      <!-- 出库表格 -->
      <el-table
        v-if="activeName === '1'"
        size="mini"
        stripe
        border
        v-loading="loading"
        :data="tableData"
      >
        <el-table-column min-width="160" show-overflow-tooltip label="客户名称" prop="userName"></el-table-column>
        <el-table-column min-width="200" label="工单编号" prop="objNum">
          <template #default="{ row }">
            <el-button type="text" @click="toDetail(row)">{{ row.objNum }}</el-button>
            <el-button type="text" @click.stop="handleCopyText(row.objNum)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column min-width="140" label="品种规格" prop="specName" show-overflow-tooltip></el-table-column>
        <el-table-column min-width="140" label="关联仓库" prop="warehouseName"></el-table-column>
        <el-table-column min-width="120" label="车牌号" prop="vehicleKey"></el-table-column>
        <el-table-column min-width="120" label="计划发货数量" prop="planQuantity"></el-table-column>
        <el-table-column min-width="120" label="实际发货数量" prop="addQuantity"></el-table-column>
        <el-table-column min-width="120" label="绩效系数" prop="performanceCoefficient"></el-table-column>
        <el-table-column min-width="120" label="绩效" prop="performancePrice"></el-table-column>
        <el-table-column width="120" label="操作" fixed="right">
          <template #default="{ row }">
            <el-button type="text" @click="$router.push('/jxcount/detail?id=' + row.id)">详情</el-button>
            <el-button type="text" v-if="hasDelete" @click="onDelete(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 入库表格 -->
      <el-table
        v-if="activeName === '2'"
        size="mini"
        stripe
        border
        v-loading="loading"
        :data="tableData"
      >
        <el-table-column min-width="160" show-overflow-tooltip label="客户名称" prop="userName"></el-table-column>
        <el-table-column min-width="200" label="工单编号" prop="objNum">
          <template #default="{ row }">
            <el-button type="text" @click="toDetail(row)">{{ row.objNum }}</el-button>
            <el-button type="text" @click.stop="handleCopyText(row.objNum)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column min-width="140" label="品种规格" prop="specName" show-overflow-tooltip></el-table-column>
        <el-table-column min-width="140" label="关联仓库" prop="warehouseName"></el-table-column>
        <el-table-column min-width="120" label="车牌号" prop="vehicleKey"></el-table-column>
        <el-table-column min-width="120" label="实际发货数量" prop="addQuantity"></el-table-column>
        <el-table-column min-width="120" label="实际收货数量" prop="trueQuantity"></el-table-column>
        <el-table-column min-width="120" label="绩效系数" prop="performanceCoefficient"></el-table-column>
        <el-table-column min-width="120" label="绩效" prop="performancePrice"></el-table-column>
        <el-table-column width="120" label="操作" fixed="right">
          <template #default="{ row }">
            <el-button type="text" @click="$router.push('/jxcount/detail?id=' + row.id)">详情</el-button>
            <el-button type="text" v-if="hasDelete" @click="onDelete(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 调拨表格 -->
      <el-table
        v-if="activeName === '3'"
        size="mini"
        stripe
        border
        v-loading="loading"
        :data="tableData"
      >
        <el-table-column min-width="160" show-overflow-tooltip label="调拨客户名称" prop="userName"></el-table-column>
        <el-table-column min-width="200" label="工单编号" prop="objNum">
          <template #default="{ row }">
            <el-button type="text" @click="toDetail(row)">{{ row.objNum }}</el-button>
            <el-button type="text" @click.stop="handleCopyText(row.objNum)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column min-width="140" label="品种规格" prop="specName" show-overflow-tooltip></el-table-column>
        <el-table-column min-width="140" label="调拨仓库" prop="warehouseName"></el-table-column>
        <el-table-column min-width="140" label="接收仓库" prop="receiveWarehouseName"></el-table-column>
        <el-table-column min-width="160" label="接收客户名称" prop="receiveUserName"></el-table-column>
        <el-table-column min-width="120" label="调拨数量" prop="transferQuantity"></el-table-column>
        <el-table-column min-width="120" label="绩效系数" prop="performanceCoefficient"></el-table-column>
        <el-table-column min-width="120" label="绩效" prop="performancePrice"></el-table-column>
        <el-table-column width="120" label="操作" fixed="right">
          <template #default="{ row }">
            <el-button type="text" @click="$router.push('/jxcount/detail?id=' + row.id)">详情</el-button>
            <el-button type="text" v-if="hasDelete" @click="onDelete(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="mt15"
        :current-page.sync="page"
        background
        layout="total, prev, pager, next"
        :total="total"
        @current-change="loadList"
      >
      </el-pagination>
    </el-card>

    <!-- 月度汇总导出弹框 -->
    <el-dialog title="选择导出月份" :visible.sync="showMonthDialog" width="420px">
      <el-form ref="monthFormRef" :model="monthForm" label-width="100px">
        <el-form-item label="导出月份" prop="yearMonth" :rules="[{ required: true, message: '请选择导出月份', trigger: 'change' }]">
          <el-date-picker
            v-model="monthForm.yearMonth"
            type="month"
            placeholder="请选择月份"
            format="yyyy-MM"
            value-format="yyyy-MM"
            style="width:100%"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showMonthDialog = false">取消</el-button>
        <el-button type="primary" @click="submitMonthExport">确定导出</el-button>
      </div>
    </el-dialog>
    <!-- 编辑绩效弹框 -->
    <el-dialog title="编辑绩效" :visible.sync="editVisible" width="500px">
      <el-form ref="editFormRef" :model="editForm" label-width="120px">
        <el-form-item label="编辑字段" prop="editField">
          <el-radio-group v-model="editForm.editField">
            <el-radio label="coefficient">绩效系数</el-radio>
            <el-radio label="price">绩效金额</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="editForm.editField === 'coefficient'" label="绩效系数" prop="performanceCoefficient">
          <el-input-number
            v-model="editForm.performanceCoefficient"
            :min="0"
            placeholder="请输入绩效系数"
            style="width:100%"
          />
        </el-form-item>

        <el-form-item v-if="editForm.editField === 'price'" label="绩效金额" prop="performancePrice">
          <el-input-number
            v-model="editForm.performancePrice"
            :precision="2"
            :min="0"
            placeholder="请输入绩效金额"
            style="width:100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import { copyText } from '@/utils/utils'
export default {
  name: 'JxCount',
  mixins: [keepAlive],
  data() {
    return {
      dateArr: [],
      searchForm: {
        startDate: '',
        endDate: ''
      },
      formData: {
        zj: '',
        cq: '',
        cj: '',
        hz: ''
      },
      showMonthDialog: false,
      monthForm: {
        yearMonth: ''
      },
      loading: false,
      activeName: '1',
      tableData: [],
      page: 1,
      total: 0,
      editVisible: false,
      editFormRef: null,
      editForm: {
        id: null,
        editField: 'coefficient',
        performanceCoefficient: null,
        performancePrice: null
      }
    }
  },
  created() {
    this.dateArr = [this.$dayjs().format('YYYY-MM-DD'), this.$dayjs().format('YYYY-MM-DD')]
    this.searchForm.startDate = this.dateArr[0]
    this.searchForm.endDate = this.dateArr[1]
    this.loadData()
    this.loadList()
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasExport() {
      return this.buttonList.includes('export')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    }
  },
  methods: {
    handleQuery() {
      this.page = 1
      this.loadData()
      this.loadList()
    },
    handleTabClick() {
      this.page = 1
      this.loadList()
    },
    handleDateChange(val) {
      if (val && val.length) {
        this.searchForm.startDate = val[0]
        this.searchForm.endDate = val[1]
      } else {
        this.searchForm.startDate = ''
        this.searchForm.endDate = ''
      }
    },
    async handleCopyText(text) {
      const success = await copyText(text)
      if (success) {
        this.$message.success('复制成功')
      } else {
        this.$message.error('复制失败，请手动复制')
      }
    },
    getFilenameFromHeader(contentDisposition) {
      if (!contentDisposition) return null
      const regex = /filename\*?=((['"]).*?\2|[^;\n]*)/
      const matches = regex.exec(contentDisposition)
      if (matches && matches[1]) {
        let filename = matches[1].replace(/['"]/g, '')
        if (filename.startsWith("utf-8''")) {
          filename = filename.substring(7)
        }
        if (filename) {
          filename = decodeURIComponent(filename)
        }
        return filename
      }
      return null
    },
    onMonthDown() {
      this.monthForm.yearMonth = ''
      this.showMonthDialog = true
      this.$nextTick(() => {
        this.$refs.monthFormRef.clearValidate()
      })
    },
    async submitMonthExport() {
      try {
        await this.$refs.monthFormRef.validate()
      } catch (e) {
        return
      }
      const params = {
        yearMonth: this.monthForm.yearMonth
      }
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.post(this.$apis.performance.exportYgPerformance, params, {
        responseType: 'blob'
      }).then(res => {
        const contentDisposition = res.headers['content-disposition']
        const fileName = this.getFilenameFromHeader(contentDisposition) || '月度汇总绩效.xlsx'
        const blob = new Blob([res.data])
        const downloadUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = downloadUrl
        a.download = fileName
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(downloadUrl)
        this.$message.success('月度汇总导出成功')
        this.showMonthDialog = false
      }).catch(() => {
        this.$message.error('月度汇总导出失败')
      }).finally(() => {
        loadingInstance.close()
      })
    },
    handleExportPdf() {
      let url = ''
      if (this.activeName === '1') {
        url = this.$apis.performance.txOutPerformancePdf
      } else if (this.activeName === '2') {
        url = this.$apis.performance.txInPerformancePdf
      } else if (this.activeName === '3') {
        url = this.$apis.performance.txTransferPerformancePdf
      }
      const body = {
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate
      }
      this.$axios.post(url, body, {
        responseType: 'blob'
      }).then(res => {
        const contentDisposition = res.headers['content-disposition']
        const fileName = this.getFilenameFromHeader(contentDisposition) || '绩效明细.pdf'
        const blob = new Blob([res.data])
        const downloadUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = downloadUrl
        a.download = fileName
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(downloadUrl)
        this.$message.success('导出成功')
      }).catch(() => {
        this.$message.error('导出失败')
      })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.performance.selectYgPerformanceJx, {
        params: {
          startDate: this.searchForm.startDate,
          endDate: this.searchForm.endDate
        }
      }).then(res => {
        if (res) {
          this.formData = res
        } else {
          this.formData = {
            zj: '0',
            cq: '0',
            cj: '0',
            hz: '0'
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    loadList() {
      this.loading = true
      let performanceType
      if (this.activeName === '1') performanceType = '2'
      else if (this.activeName === '2') performanceType = '1'
      else if (this.activeName === '3') performanceType = '3'

      const params = {
        page: this.page,
        limit: 10,
        performanceType,
        ...this.searchForm
      }
      this.$axios.get(this.$apis.performance.selectYgPerformanceByPage, { params }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    toDetail(row) {
      if (row.sourceType === 'CY') {
        this.$router.push('/cyCrkManage/detail?inventoryId=' + row.objId)
      } else if (row.sourceType === 'YC') {
        this.$router.push('/ycdeliveryOrder/detail?pickupId=' + row.objId)
      } else if (row.sourceType === 'SC') {
        this.$router.push('/productrecord/detail?recordId=' + row.objId)
      } else if (row.sourceType === 'TH') {
        this.$router.push('/deliveryOrder/detail?pickupId=' + row.objId)
      }
    },
    openEditDialog(row) {
      this.editForm.id = row.id
      this.editForm.editField = 'coefficient'
      this.editForm.performanceCoefficient = row.performanceCoefficient
      this.editForm.performancePrice = row.performancePrice
      this.editVisible = true
    },
    submitEdit() {
      const payload = {
        id: this.editForm.id
      }
      if (this.editForm.editField === 'coefficient') {
        payload.performanceCoefficient = this.editForm.performanceCoefficient
        payload.performancePrice = ''
      } else {
        payload.performancePrice = Number(this.editForm.performancePrice).toFixed(2)
        payload.performanceCoefficient = ''
      }
      this.$axios.post(this.$apis.performance.updateYgPerformance, payload).then(() => {
        this.$message.success('修改成功')
        this.editVisible = false
        this.loadList()
        this.loadData()
      })
    },
    onDelete(id) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.performance.deleteYgPerformance, {
          id
        }).then(() => {
          this.loadData()
          this.loadList()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.count-items {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.count-item {
  flex: 1;
  text-align: center;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding-bottom: 10px;
  overflow: hidden;
}
.count-item-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  padding: 10px;
  background-color: #409eff;
  color: white;
}
.count-item-value {
  font-size: 36px;
  font-weight: bold;
  color: #303133;
}
.el-card {
  position: relative;
}
.export {
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 1;
}
</style>
